module.exports = __webpack_public_path__ + "static/25-4663b7bd727f208c596528df4494a35d.jpg";